function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-anchor\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.39,25.31H8.61a1.13,1.13,0,0,1,0-2.25H31.39a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.39,29.46H8.61a1.13,1.13,0,0,1,0-2.25H31.39a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20,19.28a1.12,1.12,0,0,1-1.12-1.12V3.63a1.13,1.13,0,1,1,2.25,0V18.16A1.13,1.13,0,0,1,20,19.28Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,19.28a2.49,2.49,0,0,1-1.79-.74L14.63,15a1.12,1.12,0,0,1,0-1.59,1.13,1.13,0,0,1,1.6,0L19.8,17a.28.28,0,0,0,.4,0l3.58-3.57A1.12,1.12,0,1,1,25.37,15l-3.58,3.57A2.49,2.49,0,0,1,20,19.28Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.44,5.44,0,0,1-5.43-5.42V12.48A5.43,5.43,0,0,1,6.56,7.06H33.44a5.42,5.42,0,0,1,5.42,5.42V30.26A5.43,5.43,0,0,1,33.44,35.68ZM6.56,9.31a3.18,3.18,0,0,0-3.18,3.17V30.26a3.19,3.19,0,0,0,3.18,3.17H33.44a3.18,3.18,0,0,0,3.17-3.17V12.48a3.17,3.17,0,0,0-3.17-3.17Z",
  fill: "#231f20"
});

function SvgCmsAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsAnchor;